import React, { Component } from "react";
import { formatoSeparadorMilesValue } from '../../../generico/utils/FormatoInput'

import Select from "react-select";
import TarjetaCredito from "./TarjetaCredito"
import Prestamo from "./Prestamo"
import Rueda from "./Rueda"
import AhorroProgramado from "./AhorroProgramado"
import history from "../../login/history"
import CuentasDebito from "./CuentasDebito";
import DebitoAutomaticoService from "../../../../services/autogestion/DebitoAutomaticoService";
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import authService from "../../../../services/login/auth.service";
import ConfigService from "../../../../services/configuracion/ConfigService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

export default class AgregarPaso1 extends Component {
  constructor(props) {
    super(props);
    this.cuenta = React.createRef();
    this.refRueda = React.createRef();
    this.refAhorro = React.createRef();
    this.refTC = React.createRef();
    this.refPrestamo = React.createRef();
    this.state = this.getInitialState();
    this.getCuentasSocio = this.getCuentasSocio.bind(this);
  }

  getInitialState = () => ({
    cuentasOrigen: [],
    modalidadElegida: null,
    cuentasOrigen: [],
    optionsCuentas: [],
    itemSelected: [],
    cuentasOrigen: [],
    cargaModalidad: undefined,
    tipo: undefined,
    prestamos: undefined,
    tc: undefined,
    ruedas: undefined,
    ahorros: undefined,
    disableSgte: true,
    cuentaOrigenSelected: undefined,
    importe: undefined,
    datoTC_tarjeta: undefined,
    datoTC_tipo: undefined,
    datoTC_limite: undefined,
    datoTC_nro: undefined,
    AH_descripcion: undefined,
    AH_depositado: undefined,
    AH_cuenta: undefined,
    RUE_depositado: undefined,
    RUE_idAhorro: undefined,
    RUE_credito: undefined,
    PRE_credito: undefined,
    PRE_tipo: undefined,
    PRE_monto: undefined

  })


  componentDidMount() {
    this.getCuentasSocio();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });



  handleChangeTipoModalidadSelector = (selectedOption) => {
    if (selectedOption == null)
      this.setState({
        modalidadElegida: undefined,
        cargaModalidad: undefined,
        disableSgte: true
      });
    else {
      if (selectedOption.value === "8" || selectedOption.value === "12") {
        if (this.state.cuentaOrigenSelected !== undefined)
          this.setState({
            modalidadElegida: selectedOption.value, disableSgte: false, cargaModalidad: false,
          });
        else
          this.setState({
            modalidadElegida: selectedOption.value, disableSgte: true, cargaModalidad: false,
          });
      }
      else {
        if (this.state.cuentaOrigenSelected !== undefined)
        this.setState({
          modalidadElegida: selectedOption.value, disableSgte: true, cargaModalidad: false
        });
      }
    }
  };

  obtenerModalidadSelect() {
    var options = [];
    options.push({ value: "8", label: "APORTE" }, { value: "12", label: "SOLIDARIDAD" },
      { value: "7", label: "CREDITOS" }, { value: "10", label: "TARJETAS" },
      { value: "14", label: "RUEDAS" }, { value: "11", label: "AHORRO PROGRAMADO" });
    return (
      <Select name="tipoModalidad"
        defaultValue={this.state.modalidadElegida}
        onChange={this.handleChangeTipoModalidadSelector}
        placeholder="-- seleccione --"
        options={options}
        isClearable
        noOptionsMessage={() => 'SIN DATOS'}
      />
    );
  }
  

  /***
   * 
   * CUENTA A DEBITAR
   ***/

  selectorValue = (dataFromChild, item) => {

    if (dataFromChild === undefined) {
      this.setState({
        cuentaOrigenSelected: undefined,
        cuentaDebito: undefined,
        saldoActual: undefined,
        detalleCuenta: undefined,
        itemSelected: undefined,
      });
      return
    }

    var valores = item.label;
    var resultado = valores.split("-")
    var monto = resultado[2].split(":")

    this.setState({
      cuentaOrigenSelected: dataFromChild,
      cuentaDebito: dataFromChild.cuenta,
      saldoActual: monto[1],
      detalleCuenta: item.label,
      itemSelected: item,
    });
  };



  /***
   * TARJETAS DE CRÉDITO
   ***/

  importePagar = (respuesta) => {

    // console.log("importa a pagar "+respuesta)
    if (this.state.datoTC_tarjeta !== undefined) {
      if (respuesta === "")
        this.setState({ importe: undefined, disableSgte: true });
      else
        this.setState({ importe: respuesta, disableSgte: false });
    }

    else {
      if (respuesta === "")
        this.setState({ importe: undefined, disableSgte: true });
      else
        this.setState({ importe: respuesta, disableSgte: false });
    }
  };

  datoTC = (tarjeta, tipo, limite, nro) => {
  
    if (this.state.importe !== undefined)
      this.setState({ disableSgte: false, datoTC_tarjeta: tarjeta, datoTC_tipo: tipo, datoTC_limite: limite, datoTC_nro: nro }, this.enableNextTC);
    else
      this.setState({ datoTC_tarjeta: tarjeta, datoTC_tipo: tipo, datoTC_limite: limite, datoTC_nro: nro }, this.enableNextTC);
  };
  enableNextTC() {
    this.refTC.current.checkGrilla();
  }

  getTCSocio() {
    var options = [];
    trackPromise(
      DebitoAutomaticoService.obtenerTarjetaDebitoSocio()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigo === 0) {
            for (var i = 0; i < jsonData.datos.length; i++) {
              var contador = i + 1;
              var nro = jsonData.datos[i].numeroTarjeta;
              options.push({
                id: contador + "",
                tarjeta: nro.substring(0, 4) + "****" + nro.substring(nro.length - 4, nro.length),
                tipo: jsonData.datos[i].descripcion,
                limite: formatoSeparadorMilesValue(jsonData.datos[i].limite),
                nro: nro
              });
            }
            this.setState({ tc: options });
          }
          else {
            this.setState({ tc: options });
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        }
        ));
    return options;
  }

  /***
   * AHORRO PROGRAMADO
   ***/

  datoAhorro = (descripcion, depositado, cuenta) => {
    /*console.log(descripcion)
    console.log(depositado)
    console.log(cuenta)*/
    this.setState({ disableSgte: false, AH_descripcion: descripcion, AH_depositado: depositado, AH_cuenta: cuenta }, this.enableNextAH);

  };
  enableNextAH() {
    this.refAhorro.current.checkGrilla();
  }

  getAhorroProgramadoSocio() {
    var options = [];
    trackPromise(
      DebitoAutomaticoService.obtenerAhorroProgramadoSocio()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigo === 0) {
            for (var i = 0; i < jsonData.datos.length; i++) {
              var contador = i + 1;
              options.push({
                id: contador + "",
                descripcion: jsonData.datos[i].modalidadDescripcion,
                depositado: formatoSeparadorMilesValue(jsonData.datos[i].depositado) + " ." + jsonData.datos[i].moneda,
                ahorro: jsonData.datos[i].idAhorro
              });
            }
            this.setState({ ahorros: options });
          }
          else {
            // console.log(jsonData.codigo)
            this.setState({ ahorros: options });
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }

        }
        ));
    return options;
  }


  /***
   * RUEDA GIGANTE
   ***/

  datoRueda = (depositado, idAhorro, credito) => {
    /* console.log(depositado)
     console.log(idAhorro)
     console.log(credito)*/
    this.setState({ disableSgte: false, RUE_depositado: depositado, RUE_idAhorro: idAhorro, RUE_credito: credito }, this.enableNextRueda);

  };
  enableNextRueda() {
    this.refRueda.current.checkGrilla();
  }

  getRuedasSocio() {
    var options = [];
    trackPromise(
      DebitoAutomaticoService.obtenerRuedaSocio()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigo === 0) {
            for (var i = 0; i < jsonData.datos.length; i++) {
              var contador = i + 1;
              options.push({
                id: contador + "",
                descripcion: "Rueda Gigante",
                depositado: formatoSeparadorMilesValue(jsonData.datos[i].deposito) + " ." + jsonData.datos[i].idMoneda,
                grupo: jsonData.datos[i].idAhorro + " " + jsonData.datos[i].idGrupo,
                idAhorro: jsonData.datos[i].idAhorro,
                cuentaAhorro: jsonData.datos[i].cuentaAhorro,
                idGrupo: jsonData.datos[i].idGrupo,
                contrato: jsonData.datos[i].nroContrato,
                plazo: jsonData.datos[i].plazo,
                credito: jsonData.datos[i].idAhorro + "- Rueda Gigante " + jsonData.datos[i].idGrupo,
              });
            }
            this.setState({ ruedas: options });
          }
          else {
            this.setState({ ruedas: options });
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }

        }
        ));
    return options;
  }

  /***
   * PRESTAMOS
   ***/

  datoPrestamo = (credito, tipo, monto) => {
    /*console.log(credito)
    console.log(tipo)
    console.log(monto)*/
    this.setState({ disableSgte: false, PRE_credito: credito, PRE_tipo: tipo, PRE_monto: monto }, this.enableNext);
  };

  
  enableNext() {
    this.refPrestamo.current.checkGrilla();
  }

  getPrestamosSocio() {
    var options = [];
    trackPromise(
      DebitoAutomaticoService.obtenerPrestamosSocio()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigo === 0) {
            for (var i = 0; i < jsonData.datos.length; i++) {
              var contador = i + 1;
              options.push({
                id: contador + "",
                credito: jsonData.datos[i].idCredito,
                tipo: jsonData.datos[i].descripcion,
                monto: formatoSeparadorMilesValue(jsonData.datos[i].monto) + jsonData.datos[i].idMoneda
              });
            }
            this.setState({ prestamos: options });
          }

          else {
            this.setState({ prestamos: options });
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        }
        ));
    return options;
  }


  obtenerCuentaSocio() {

    if (this.state.modalidadElegida === null || this.state.modalidadElegida === undefined) {
      return (
        <div></div>
      );
    }

    switch (this.state.modalidadElegida) {

      case "7":

        if (this.state.prestamos === undefined)
          this.getPrestamosSocio()
        return (
          <Prestamo ref={this.refPrestamo} prestamos={this.state.prestamos} datoPrestamo={this.datoPrestamo.bind(this)} />
        );
      case "10":

        if (this.state.tc === undefined)
          this.getTCSocio()
        return (
          <TarjetaCredito ref={this.refTC} tarjeta={this.state.tc} importePagar={this.importePagar.bind(this)} datoTC={this.datoTC.bind(this)} />
        );
      case "14":

        if (this.state.ruedas === undefined)
          this.getRuedasSocio()
      
        return (
          <Rueda ref={this.refRueda} ruedas={this.state.ruedas} datoRueda={this.datoRueda.bind(this)} />
        );
      case "11":

        if (this.state.ahorros === undefined)
          this.getAhorroProgramadoSocio()
        
        return (
          <AhorroProgramado ref={this.refAhorro} ahorros={this.state.ahorros} datoAhorro={this.datoAhorro.bind(this)} />
        );
    }

  }

  volverDebitoAutomatico = (e) => {
    //history.push('/debitoAutomatico');
    history.push(ConfigService.getPathByName("debitoAutomatico")?.url);
    window.location.reload();
  }

  getCuentasSocio() {
    var options = [];
    trackPromise(
      DebitoAutomaticoService.obtenerCuentaDebitoSocio()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigo === 0) {
            for (var i = 0; i < jsonData.datos.length; i++) {
              options.push({
                value: jsonData.datos[i].idAhorro,
                label:
                  jsonData.datos[i].idAhorro +
                  "-" +
                  jsonData.datos[i].descripcion +
                  "-" +
                  " Saldo: " +
                  formatoSeparadorMilesValue(jsonData.datos[i].saldoTotal) + " " +
                  jsonData.datos[i].idMoneda +
                  ".",
              });
            }
            this.setState({ cuentasOrigen: jsonData.datos, optionsCuentas: options, tipo: undefined });
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        }
        ));
    return options;
  }

  loadDatosSocio = () => {
    if (this.state.optionsCuentas != undefined)
      return this.state.optionsCuentas
    else {
      return this.getCuentasSocio()
    }
  }

  continuar = () => {
    var modalidad = "";
    var options = [];
    switch (this.state.modalidadElegida) {
      case "7":
        modalidad = "Prestamos"
        options.push({
          cuenta_debito: this.state.detalleCuenta,
          saldo: this.state.saldoActual,
          modalidad: modalidad,
          nroModalidad: "7",
          cuenta_credito: this.state.PRE_credito + " - " + this.state.PRE_tipo,
          PRE_credito: this.state.PRE_credito
        });
        this.props.respuestaPaso1(JSON.parse(JSON.stringify(options)), modalidad, this.state.cuentaOrigenSelected);
        break;
      case "8":
        modalidad = "Aporte"
        options.push({
          cuenta_debito: this.state.detalleCuenta,
          saldo: this.state.saldoActual,
          modalidad: modalidad,
          nroModalidad: "8",
          cuenta_credito: " - "
        });
        this.props.respuestaPaso1(JSON.parse(JSON.stringify(options)), modalidad, this.state.cuentaOrigenSelected);
        break;
      case "10":
        modalidad = "Tarjeta de Crédito"
        var valor_porcentaje = "100";
        if (this.state.importe === "1")
          valor_porcentaje = "5"

        options.push({
          cuenta_debito: this.state.detalleCuenta,
          saldo: this.state.saldoActual,
          modalidad: modalidad,
          nroModalidad: "10",
          cuenta_credito: " - ",
          TC_tarjeta: this.state.datoTC_tarjeta,
          TC_tipo: this.state.datoTC_tipo,
          TC_limite: this.state.datoTC_limite,
          TC_nro: this.state.datoTC_nro,
          TC_porcentaje: valor_porcentaje
        });
        this.props.respuestaPaso1(JSON.parse(JSON.stringify(options)), modalidad, this.state.cuentaOrigenSelected);
        break;
      case "14":
        modalidad = "Rueda Gigante"
        options.push({
          cuenta_debito: this.state.detalleCuenta,
          saldo: this.state.saldoActual,
          modalidad: modalidad,
          nroModalidad: "14",
          cuenta_credito: this.state.RUE_credito,
          RUE_depositado: this.state.RUE_depositado,
          RUE_idAhorro: this.state.RUE_idAhorro,
          RUE_credito: this.state.RUE_credito,

        });
        this.props.respuestaPaso1(JSON.parse(JSON.stringify(options)), modalidad, this.state.cuentaOrigenSelected);
        break;
      case "11":
        modalidad = "Ahorro Programado"
        options.push({
          cuenta_debito: this.state.detalleCuenta,
          saldo: this.state.saldoActual,
          modalidad: modalidad,
          nroModalidad: "11",
          cuenta_credito: this.state.AH_cuenta + " - " + this.state.AH_descripcion,
          AH_ahorro: this.state.AH_cuenta
        });
        this.props.respuestaPaso1(JSON.parse(JSON.stringify(options)), modalidad, this.state.cuentaOrigenSelected);
        break;
      case "12":
        modalidad = "Solidaridad"
        options.push({
          cuenta_debito: this.state.detalleCuenta,
          saldo: this.state.saldoActual,
          modalidad: modalidad,
          nroModalidad: "12",
          cuenta_credito: " - "
        });
        this.props.respuestaPaso1(JSON.parse(JSON.stringify(options)), modalidad, this.state.cuentaOrigenSelected);
        break;
    }

    this.nextStep.click();
  }



  render() {
    var cuentas = this.loadDatosSocio();
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <div className="row">
              <div className="col-md-4">
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Cuenta
                    </span>
                  </div>
                </span>
              </li>
              </div>
              <div className="col-md-4">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">
                      Datos de Verificación
                    </span>
                  </div>
                </span>
              </li>
              </div>
             <div className="col-md-4">
             <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
             </div>
             </div>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <div className="row">
              <div className="col-lg-8 col-md-10">
                {<CuentasDebito ref="cuenta" titulo="Seleccione la Cuenta Origen (a debitar) " presentacion="SELECT" selectorValue={this.selectorValue.bind(this)} itemSelected={this.state.tipo} cuentas={cuentas} />}

              </div>
            </div>
            <div className="row">
              <div className="col-lg-8 col-md-10">
                <div className="form-group">
                  <label className="input-label-bold">
                    Seleccione la Modalidad *
                        </label>
                  {this.obtenerModalidadSelect()}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-lg-10 col-md-10">
            <div className="form-group">
              {this.obtenerCuentaSocio()}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8 col-md-6 col-12">
          <label className="input-label-bold-obligatorio float-left">
              (*) Campos Obligatorios
                  </label>
          </div>
          <div className="col-lg-2 col-md-3 col-12">
          <button className="btn btn-cu-quintary btn-consulta" onClick={this.volverDebitoAutomatico}><FontAwesomeIcon icon={faArrowLeft} /> Volver al Listado</button>

          </div>
          <div className="col-lg-2 col-md-3 col-12">
          <button disabled={this.state.disableSgte}
              className="btn btn-cu-primary"
              onClick={() => {
                this.continuar();
              }}>
              Continuar <FontAwesomeIcon icon={faArrowRight} />
                  </button>
            <button
              hidden
              ref={(a) => (this.nextStep = a)}
              className="btn btn-cu-primary"
              onClick={this.props.nextStep}
            ></button>
          </div>
        </div>
      </div>
    );
  }
}